<script lang="ts">import ActionButton from "../ActionButton/ActionButton.svelte";
export let handleClick = (e) => {
    console.log('Cancel: ');
};
</script>
  
  <ActionButton onClick={handleClick} outline={true} title="Cancel"/>